import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.555 6.41555L11.4384 3.71985L10.5425 4.09094L11.6592 6.78696C11.9505 6.64948 12.2493 6.52542 12.555 6.41555Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.15125 8.46541L7.08617 6.40032L6.40049 7.086L8.46557 9.15108C8.68317 8.91184 8.91201 8.683 9.15125 8.46541Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.78708 11.6589L4.09106 10.5422L3.71998 11.4381L6.41565 12.5547C6.52552 12.2491 6.6496 11.9502 6.78708 11.6589Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.41561 19.4449L3.71985 20.5615L4.09094 21.4574L6.78703 20.3406C6.64955 20.0494 6.52548 19.7505 6.41561 19.4449Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.46547 22.8485L6.40033 24.9136L7.08601 25.5993L9.15114 23.5342C8.9119 23.3166 8.68306 23.0877 8.46547 22.8485Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.659 25.2126L10.5423 27.9087L11.4382 28.2798L12.5548 25.5841C12.2492 25.4742 11.9503 25.3501 11.659 25.2126Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4452 25.584L20.5618 28.2798L21.4577 27.9087L20.3409 25.2125C20.0496 25.35 19.7508 25.4741 19.4452 25.584Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8486 23.5341L24.9138 25.5993L25.5995 24.9137L23.5343 22.8484C23.3167 23.0877 23.0878 23.3165 22.8486 23.5341Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.2126 20.3407L27.9088 21.4575L28.2799 20.5616L25.5841 19.4449C25.4742 19.7505 25.3501 20.0494 25.2126 20.3407Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.584 12.5547L28.2798 11.438L27.9087 10.5422L25.2126 11.6589C25.3501 11.9502 25.4742 12.249 25.584 12.5547Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5342 9.15114L25.5993 7.08597L24.9137 6.40029L22.8485 8.46546C23.0877 8.68306 23.3166 8.9119 23.5342 9.15114Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3408 6.78709L21.4575 4.09098L20.5616 3.71989L19.445 6.41565C19.7506 6.52552 20.0495 6.6496 20.3408 6.78709Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.82949 15.5151H2.90906V16.4848H5.82949C5.82196 16.3241 5.81815 16.1625 5.81815 15.9999C5.81815 15.8374 5.82196 15.6757 5.82949 15.5151Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5151 26.1704V29.0908H16.4848V26.1704C16.3241 26.1779 16.1625 26.1817 16 26.1817C15.8374 26.1817 15.6758 26.1779 15.5151 26.1704Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.1704 16.4848H29.0909V15.5151H26.1704C26.178 15.6757 26.1818 15.8374 26.1818 15.9999C26.1818 16.1625 26.178 16.3241 26.1704 16.4848Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3723 5.99974L14.6275 5.99974C14.3392 5.99974 14.1516 5.6963 14.2806 5.4384L15.653 2.6936C15.7959 2.40772 16.2039 2.40772 16.3468 2.6936L17.7192 5.4384C17.8482 5.6963 17.6607 5.99974 17.3723 5.99974Z",
			fill: "#E25345"
		})
	]
});
export default SvgCompass;
